import api from "@/lib/axios";

export interface LocationData {
  house_number: string;
  road: string;
  suburb: string;
  city: string;
  municipality: string;
  state_district: string;
  county: string;
  state: string;
  state_code: string;
  region: string;
  postcode: string;
  country: string;
  country_code: string;
  display_name: string;
  formatted_address: string;
  primary_address: string;
}

export interface LocationResponse {
  errors: boolean;
  data: LocationData;
}

export const lastTrackerPositionService = {
  async getAddressInfo(lat: number, lng: number): Promise<LocationResponse> {
    const response = await api.get("/address_info", {
      params: { lat: lat, lng: lng },
    });
    return response.data;
  },
};
